// @flow

import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';

import { GoogleSSOButton, SignupType } from '@zapier/auth';

import TrackData from 'app/track/Data';

import { type Dispatch } from 'app/common/types';

type OwnProps = {
  queryParams: {
    use_case_slug?: string,
  },
};

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => ({
  onClick: async (event, href) => {
    event.preventDefault();
    const useCaseSlug = ownProps.queryParams
      ? ownProps.queryParams.use_case_slug
      : '';

    try {
      await TrackData.trackSignupIntent(SignupType.sso, {
        useCaseSlug,
      });
    } catch (e) {
      console.error(e);
    } finally {
      dispatch(routeTo(href));
    }
  },
});

export default connect(null, mapDispatchToProps)(GoogleSSOButton);
